import { useState } from 'react';
import { Button } from '../form/button';

export const ButtonGroup = <T,>({
  items,
  onClick,
  selected,
}: {
  items: { label: string; value: T }[];
  onClick: (value: T) => void;
  selected?: T;
}) => {
  const [selectedButton, setSelectedButton] = useState<number>(
    selected
      ? items.findIndex((v) => {
          return v.value == selected;
        })
      : 0,
  );

  const handleOnClick = (buttonIdx: number, value: T) => {
    setSelectedButton(buttonIdx);
    onClick(value);
  };

  return (
    <>
      <div className={'flex'}>
        {items.map(({ label, value }, i) => (
          <Button
            key={i}
            className={selectedButton === i ? 'button-primary' : 'button-tertiary'}
            onClick={() => handleOnClick(i, value)}
          >
            {label}
          </Button>
        ))}
      </div>
    </>
  );
};
